import React from "react";
import { Crown, Shield, Eye, Moon, PawPrint, Heart } from "lucide-react";
import { rankStyle } from "../lib/ranks";

const ICONS = { crown: Crown, shield: Shield, eye: Eye, moon: Moon, wolf: PawPrint, heart: Heart };

export function RankBadge({ rank, className = "", showIcon = true, ...props }) {
  const style = rankStyle(rank);
  const Icon = ICONS[style.icon] || Moon;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-semibold tracking-wide ${style.bg} ${style.text} ${style.border} ${className}`}
      {...props}
    >
      {showIcon && <Icon className="w-3 h-3" />}
      {rank}
    </span>
  );
}
